import { API } from '../apis/limeAuthUtils/apiWrapper';
import { isMidwayUser } from '../lib/utils';
import { FEDERATED_USER_FTDF_EXPIRATION, OTHER_USER_FTDF_EXPIRATION } from '../lib/constants';

async function CreateJwtTokenAPI(expiration) {
    /**
     * function to create jwt token for user to redirect to ftdf page
     * Identity (user, email, idp, custom_group) is resolved from OIDC authorizer context
     * Only expiration is sent in the body
     */
    const apiName = 'v2/permission-validate';
    const myInit = {
        body: {
            expiration: expiration,
        },
    };
    return await API.post(apiName, '/v2/create_jwt_token', myInit);
}

export async function generateJwtToken() {
    /**
     * function to create jwt token for normal user
     * Check if user is from Midway to determine expiration time
     * Identity is resolved from OIDC authorizer context on the backend
     */
    const isMidway = isMidwayUser();
    const expiration = isMidway ? FEDERATED_USER_FTDF_EXPIRATION : OTHER_USER_FTDF_EXPIRATION;
    return await CreateJwtTokenAPI(expiration);
}

export async function authenticateByBot(username, password) {
    /**
     * function to create jwt token for bot account user
     */
    const apiName = 'v2/permission-validate';
    const myInit = {
        body: {
            username: username,
            password: password,
            expiration: OTHER_USER_FTDF_EXPIRATION,
        },
    };
    return await API.post(apiName, '/v2/authenticate_ftdf_by_bot', myInit);
}
